import React, { useEffect, useState } from "react";
import axiosInstance from "../axiosInstance"; // Import axiosInstance
import "./Form.css";
import { useLocation } from "react-router-dom";

export const Events = () => {
  const [formData, setFormData] = useState({
    cust_sr_no: "",
    cust_mob_no: "",
    cust_veh_no: "",
  });
  const location = useLocation();
  const { vehicleNumber = "", srNumber = "" } = location?.state || {};

  const [srNumbers, setSrNumbers] = useState([]);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    let error = "";

    if (name === "cust_mob_no") {
      const numericValue = value.replace(/\D/g, "");
      if (!numericValue.trim()) {
        error = "Enter your mobile number";
      } else if (numericValue.length !== 10) {
        error = "Mobile number must be exactly 10 digits.";
      }

      setFormData({ ...formData, [name]: numericValue.slice(0, 10) });
    } else {
      setFormData({ ...formData, [name]: value });
    }

    setErrors({ ...errors, [name]: error });
  };

  // const handleSearch = async () => {
  //   if (!formData.cust_veh_no.trim()) {
  //     setErrors({ ...errors, cust_veh_no: "Enter your Registration number" });
  //     return;
  //   }

  //   const token = localStorage.getItem("token");
  //   if (!token) {
  //     alert("Authentication token is missing. Please log in.");
  //     return;
  //   }

  //   try {
  //     const response = await axiosInstance.post(
  //       "/pifir/get_vehicle_sr_details/",
  //       { registration_num: formData.cust_veh_no },
  //       {
  //         headers: { Authorization: `Bearer ${token}` },
  //       }
  //     );

  //     const data = response.data;
  //     if (!data.sr_number || data.sr_number.length === 0) {
  //       throw Error("No open SR found for this Registration Number.");
  //     }
  //     setSrNumbers(data.sr_number || []);
  //     setFormData({
  //       ...formData,
  //       cust_sr_no: data.sr_number.length >= 1 ? data.sr_number[0] : "",
  //       cust_mob_no: data.mobile_number,
  //     });

  //     setErrors({});
  //   } catch (error) {
  //     console.error("API Call Failed:", error);
  //     alert("No details found for this Registration Number.");
  //   }
  // };

  
  const handleSearch = async () => {
  if (!formData.cust_veh_no.trim()) {
    setErrors({ ...errors, cust_veh_no: "Enter your Registration number" });
    return;
  }

  const token = localStorage.getItem("token");
  if (!token) {
    setSuccessMessage("Authentication token is missing. Please log in.");
    setShowPopup(true);
    return;
  }

  try {
    const response = await axiosInstance.post(
      "/pifir/get_vehicle_sr_details/",
      { registration_num: formData.cust_veh_no },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const data = response.data;

    if (!data.sr_number || data.sr_number.length === 0) {
      setSuccessMessage("No open sr numbers are available against this number");
      setShowPopup(true);
      return;
    }

    setSrNumbers(data.sr_number || []);
    setFormData({
      ...formData,
      cust_sr_no: data.sr_number.length >= 1 ? data.sr_number[0] : "",
      cust_mob_no: data.mobile_number,
    });

    setErrors({});
  } catch (error) {
    console.error("API Call Failed:", error);
    if (error.response && error.response.status === 412) {
      setSuccessMessage("Data loading failed");
    } else {
      setSuccessMessage("No open sr numbers are available against this number");
    }
    setShowPopup(true);
  }
};

  const validateForm = (data) => {
    const errors = {};

    if (!data.cust_veh_no.trim()) {
      errors.cust_veh_no = "Enter your Registration number";
    }

    if (!data.cust_sr_no.trim()) {
      errors.cust_sr_no = "Select your SR number";
    }

    if (!data.cust_mob_no.trim() || data.cust_mob_no.length !== 10) {
      errors.cust_mob_no = "Enter your 10-digit mobile number";
    }

    return errors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm(formData);
    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      try {
        await axiosInstance.post(
          "/pifir/sendlinkotp/",
          {
            cust_sr_no: formData.cust_sr_no,
            cust_mob_no: formData.cust_mob_no,
            cust_veh_no: formData.cust_veh_no,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        setSuccessMessage(`OTP shared successfully to ${formData.cust_mob_no}`);
        setShowPopup(true);
      } catch (error) {
        console.error("API Error:", error);
        if (error.response && error.response.status === 400) {
          setSuccessMessage(error.response.data.msg);
          setShowPopup(true);
        } else {
          alert("Failed to send the OTP. Please try again later.");
        }
      }
    } else {
      console.log("Form validation failed.");
    }
  };

  const closePopup = () => {
    setShowPopup(false);
    setSuccessMessage("");
  };

  useEffect(() => {
    if (vehicleNumber && srNumber) {
      setFormData({
        ...formData,
        cust_veh_no: vehicleNumber,
        cust_sr_no: srNumber,
      });
    }
  }, []);

  return (
    <div className="form-container">
      <h2 className="form-title">Provide Following Details:</h2>
      <p style={{ color: "red" }}>Used for Non-Smartphone Customer</p>

      <form onSubmit={handleSubmit} autoComplete="off">
        <div>
          <label className="form-label">Customer Registration Number:</label>
          <div className="search-wrapper">
            <input
              className="form-input"
              type="text"
              name="cust_veh_no"
              value={formData.cust_veh_no}
              onChange={handleChange}
              disabled={!!vehicleNumber}
            />
            <button
              type="button"
              className="search-button"
              onClick={handleSearch}
              disabled={!!vehicleNumber && !!srNumber}
            >
              Search
            </button>
          </div>
          {errors.cust_veh_no && (
            <span className="error-message">{errors.cust_veh_no}</span>
          )}
        </div>

        <div>
          <label className="form-label">Customer SR Number:</label>
          {srNumbers.length > 1 ? (
            <select
              className="form-input"
              name="cust_sr_no"
              value={formData.cust_sr_no}
              onChange={handleChange}
              disabled={!!srNumber}
            >
              {srNumbers.map((sr, index) => (
                <option key={index} value={sr}>
                  {sr}
                </option>
              ))}
            </select>
          ) : (
            <input
              className="form-input"
              type="text"
              name="cust_sr_no"
              value={formData.cust_sr_no}
              readOnly
            />
          )}
          {errors.cust_sr_no && (
            <span className="error-message">{errors.cust_sr_no}</span>
          )}
        </div>

        <div>
          <label className="form-label">Customer Mobile Number:</label>
          <input
            className="form-input"
            type="text"
            name="cust_mob_no"
            value={formData.cust_mob_no}
            onChange={handleChange}
            autoComplete="new-password"
          />
          {errors.cust_mob_no && (
            <span className="error-message">{errors.cust_mob_no}</span>
          )}
        </div>

        <button className="submit-button" type="submit">
          Submit
        </button>
      </form>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-content">
            <p>{successMessage}</p>
            <button className="close-popup-btn" onClick={closePopup}>
              OK
            </button>
          </div>
        </div>
      )}

      
    </div>
  );
};
